import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {

  @Input() imageSrc: string;
  constructor() { }

  ngOnInit(): void {
    if (!this.imageSrc)
      this.imageSrc = '/assets/images/male.png'
  }

}
